module.exports = "/wp-content/plugins/farmacy/assets/js/images/menu-flowers-icon-2-5d017e2045eab10d55542be16d970472.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/elo-app/img/category_icons/menu-flowers-icon-2.svg
 ** module id = 1006
 ** module chunks = 1 75
 **/